import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import Utils from '@/common/utils';
import { getLocalState } from '@/common/utils/store';

import {
  TDashboardMainFilterWithRegion,
  TDashboardsTableFilterPayload,
  TMainFilterPayload,
} from '../../types/dashboards';
import { DASHBOARDS_VES_ACTIONS_NAME, DASHBOARDS_VES_MUTATIONS_NAME } from './name';
import { TDashboardStoreState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export function getRegionStatistic(context: ActionContext<TDashboardStoreState, unknown>, payload: TMainFilterPayload) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getRegionStatistic,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setRegionStatistic),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getRegionStatistic),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getTopCountryPartners(
  context: ActionContext<TDashboardStoreState, unknown>,
  payload: TMainFilterPayload,
) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getTopCountryPartners,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setTopCountryPartners),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getTopCountryPartners),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getTopEffectiveRegions(
  context: ActionContext<TDashboardStoreState, unknown>,
  payload: TBaseFilterPayload<TDashboardMainFilterWithRegion>,
) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getTopEffectiveRegions,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setTopEffectiveRegions),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getTopEffectiveRegions),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getTopEffectiveRegionsRating(
  context: ActionContext<TDashboardStoreState, unknown>,
  payload: TMainFilterPayload,
) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getTopEffectiveRegionsRating,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setTopEffectiveRegionsRating),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getTopEffectiveRegionsRating),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getEventsCountByTypes(
  context: ActionContext<TDashboardStoreState, unknown>,
  payload: TMainFilterPayload,
) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getEventsCountByTypes,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setEventsCountByTypes),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getEventsCountByTypes),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getAgreementsCountByTypes(
  context: ActionContext<TDashboardStoreState, unknown>,
  payload: TMainFilterPayload,
) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getAgreementsCountByTypes,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setAgreementsCountByTypes),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getAgreementsCountByTypes),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getEventTypes(context: ActionContext<TDashboardStoreState, unknown>) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getEventTypes,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setEventTypes),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getEventTypes),
    },
    {},
  );
}

export function getEventVedTypes(context: ActionContext<TDashboardStoreState, unknown>) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getEventVedTypes,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setEventVedTypes),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getEventVedTypes),
    },
    {},
  );
}

export function getEventStatuses(context: ActionContext<TDashboardStoreState, unknown>) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getEventStatuses,
      mutate: getLocalState(DASHBOARDS_VES_MUTATIONS_NAME.setEventStatuses),
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getEventStatuses),
    },
    {},
  );
}

export function getPlannedEvents(
  context: ActionContext<TDashboardStoreState, unknown>,
  payload: TDashboardsTableFilterPayload,
) {
  return request.call(
    null,
    context,
    {
      url: links.ves.dashboards.getPlannedEvents,
      name: getLocalState(DASHBOARDS_VES_ACTIONS_NAME.getPlannedEvents),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function exportRegionEffectivnessRatingExcel(
  _context: ActionContext<TDashboardStoreState, unknown>,
  payload: TMainFilterPayload & { fileName?: string },
) {
  await Utils.downloadFile(
    links.ves.dashboards.exportregioneffectivnessratingExcel,
    payload.fileName || 'Рейтинг.xlsx',
    payload.params,
    true,
  );

  return { success: true };
}
